import React from 'react';
import { Box } from '@mui/material';

import Header from './Header';
import ClanScoreboard from './ClanScoreboard';
import PurrformanceChart from './PurrformanceCharts';
import TopMewllionaires from './TopMewllionaires';
import { Footer } from '../common/Footer';

function Clans() {
    return (
        <Box sx={{ background: '#F6F9FC' }}>
            <Header />
            <ClanScoreboard />
            <PurrformanceChart />
            <TopMewllionaires />
            <Footer />
        </Box>
    );
}

export default Clans;
